(function () {
  const THRESHOLD = window.__cpShippingThreshold || 3500;
  let slideshowReplaced = false;

  function formatEuro(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

function replaceSlideshow() {
    if (slideshowReplaced) return;
    const slideshow = document.querySelector('slideshow-component');
    if (!slideshow) return;

    const colors = window.__cpShippingColors || {};
    const colorProgress = colors.progress || '#00C4A7';

    const wrapper = document.createElement('div');
    wrapper.className = 'announcement-bar cp-shipping-active';
    wrapper.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;padding:10px 0px';
    wrapper.innerHTML = `
      <p class="announcement-bar__message h5" style="margin:0 0 8px;text-align:center;color:white;">
        <span id="announcement-bar-text"></span>
      </p>
      <div id="announcement-bar-progress-wrapper" style="display:none;width:100%;height:6px;background:rgba(255,255,255,0.15);border-radius:999px;">
        <div id="announcement-bar-progress" style="display:block;height:6px;border-radius:999px;width:0%;background-color:${colorProgress};transition:width 0.4s ease;"></div>
      </div>
      <div id="announcement-bar-progress-labels" style="display:none;justify-content:space-between;width:100%;margin-top:4px;font-size:11px;color:color:#00C4A7;">
        <span>€0</span>
        <span>€${(THRESHOLD / 100).toFixed(0)} · GRATIS</span>
      </div>
    `;

    slideshow.parentNode.replaceChild(wrapper, slideshow);
    slideshowReplaced = true;
  }

function updateBanner(cart) {
    const truckIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline;vertical-align:middle;margin-right:6px;"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>`;

    const total = cart.total_price;
    const pct = Math.min((total / THRESHOLD) * 100, 100);
    const texts = window.__cpShippingTexts || {};
    const colors = window.__cpShippingColors || {};
    const colorProgress = colors.progress || '#00C4A7';
    const colorReached = colors.reached || '#90EE90';

    if (total > 0) replaceSlideshow();

    const text = document.querySelector('#announcement-bar-text');
    const bar = document.querySelector('#announcement-bar-progress');
    const progressWrapper = document.querySelector('#announcement-bar-progress-wrapper');
    const labels = document.querySelector('#announcement-bar-progress-labels');
    if (!text || !bar) return;

    if (progressWrapper) progressWrapper.style.display = total === 0 ? 'none' : 'block';
    if (labels) labels.style.display = total === 0 ? 'none' : 'flex';

    bar.setAttribute('style',
      'display:block;height:6px;border-radius:999px;transition:width 0.4s ease;' +
      'width:' + pct + '%;' +
      'background-color:' + (total >= THRESHOLD ? colorReached : colorProgress) + ';'
    );

if (total === 0) {
      text.innerHTML = truckIcon + (texts.default || 'Gratis verzending vanaf ' + formatEuro(THRESHOLD));
    } else if (total >= THRESHOLD) {
      text.innerHTML = truckIcon + (texts.reached || 'Gelukt <span class="cp-amount">je verzending is gratis!</span>');
    } else {
      const remaining = THRESHOLD - total;
      const progressText = texts.progress || 'Nog {remaining} en je verzending is gratis';
      text.innerHTML = truckIcon + progressText.replace('{remaining}', '<span class="cp-amount">' + formatEuro(remaining) + '</span>');
    }
  }

function updateCartDrawer(cart) {
    const drawerBar = document.querySelector('#cart-drawer-shipping-bar');
    const text = document.querySelector('#cart-drawer-shipping-text');
    const bar = document.querySelector('#cart-drawer-shipping-progress');
    const spent = document.querySelector('#cart-drawer-shipping-spent');
    const thresholdLabel = document.querySelector('#cart-drawer-shipping-threshold-label');
    if (!text || !bar) return;

    const total = cart.total_price;

    if (total === 0) {
      if (drawerBar) drawerBar.style.display = 'none';
      return;
    }

    if (drawerBar) drawerBar.style.display = 'block';

    const pct = Math.min((total / THRESHOLD) * 100, 100);
    const texts = window.__cpShippingTexts || {};
    const colors = window.__cpShippingColors || {};
    const colorProgress = colors.progress || '#00C4A7';
    const colorReached = colors.reached || '#90EE90';

    bar.setAttribute('style',
      'display:block;height:6px;border-radius:999px;transition:width 0.4s ease;' +
      'width:' + pct + '%;' +
      'background-color:' + (total >= THRESHOLD ? colorReached : colorProgress) + ';'
    );

    if (total >= THRESHOLD) {
      text.innerHTML = texts.reached || 'Je hebt <span style="color:#00C4A7;">gratis verzending</span>';
      if (spent) spent.innerHTML = 'Gratis verzending toegepast bij de checkout';
      if (thresholdLabel) thresholdLabel.style.display = 'none';
    } else {
      const remaining = THRESHOLD - total;
      const progressText = texts.progress || 'Nog {remaining} tot gratis verzending';
      text.innerHTML = progressText.replace('{remaining}', '<span style="color:#00C4A7;font-weight:700;">' + formatEuro(remaining) + '</span>');
      if (spent) spent.innerHTML = formatEuro(total) + ' van <strong>' + formatEuro(THRESHOLD) + '</strong>';
      if (thresholdLabel) thresholdLabel.style.display = 'flex';
    }
  }

  function fetchCart() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        updateBanner(cart);
        updateCartDrawer(cart);
      });
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const result = originalFetch.apply(this, args);
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      result.then(() => fetchCart());
    }
    return result;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      this.addEventListener('load', fetchCart);
    }
    return originalOpen.apply(this, [method, url, ...rest]);
  };

  document.addEventListener('DOMContentLoaded', fetchCart);
  if (document.readyState !== 'loading') fetchCart();

  // Herlaad cart drawer inhoud zodra drawer opengaat
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(() => {
        if (!drawer.classList.contains('is-empty')) {
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => updateCartDrawer(cart));
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  });

})();